import { Grid, Stack, useMediaQuery, useTheme } from '@mui/material';
import { v4 as uuidv4 } from 'uuid';
import ArticleCardSkeleton from '../ArticleCard/ArticleCardSkeleton';
import { ArticleCardVariant } from '../ArticleCard/CardUtils';

interface ArticlesListSkeletonProps {
  readonly limit?: number;
  readonly showGrid?: boolean;
  readonly hideCoverImages?: boolean;
  readonly columns?: number;
  readonly cardVariant?: ArticleCardVariant;
}
export default function ArticleListSkeleton({
  limit = 10,
  showGrid = false,
  hideCoverImages = false,
  columns = 2,
  cardVariant,
}: ArticlesListSkeletonProps) {
  const theme = useTheme();
  const showLargeVariant = useMediaQuery(theme.breakpoints.up('sm'));

  const components = [...Array(limit)].map(() => {
    const id = uuidv4();
    return (
      <ArticleCardSkeleton
        key={'article-skeleton-' + id}
        variant={cardVariant ?? (showLargeVariant ? 'default' : 'mobile')}
        data-uuid={id}
        hideCoverImage={hideCoverImages}
      />
    );
  });

  return (
    <>
      {showGrid === false && (
        <Stack
          useFlexGap
          sx={{
            paddingX: 0,
            gap: 1,
          }}
        >
          {components}
        </Stack>
      )}
      {showGrid && (
        <Grid container columnSpacing={3} rowSpacing={2}>
          {components.map((component) => (
            <Grid
              key={`article-list-grid-skeleton-${component.props['data-uuid']}`}
              size={{ xs: 12, md: 12 / columns }}
            >
              {component}
            </Grid>
          ))}
        </Grid>
      )}
    </>
  );
}
